/**
 * shop-checkout (React) — design hérité des CSS shop enqueued globalement
 * (classes .gas-checkout-*, .gas-form-field, .gas-payment-method,
 * .gas-checkbox-custom réutilisées à l'identique du tunnel Vue).
 */
.gas-shop-checkout-submit-button[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
}

.gas-checkout-quote-status {
    margin: 0 0 var(--gas-space-2, 8px);
    color: var(--gas-color-text-muted, #666);
    font-size: var(--gas-font-size-sm, 14px);
}

.gas-shipping-methods {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2, 8px);
}

.gas-shipping-method {
    display: flex;
    align-items: center;
    gap: var(--gas-space-2, 8px);
    padding: var(--gas-space-3, 12px);
    border: 1px solid var(--gas-color-border, #ddd);
    border-radius: var(--gas-radius-md, 8px);
    cursor: pointer;
    background: var(--gas-color-surface, #fff);
}

.gas-shipping-method--active {
    border-color: var(--gas-color-primary, #2563eb);
    box-shadow: 0 0 0 1px var(--gas-color-primary, #2563eb);
}

.gas-shipping-method--disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.gas-shipping-method__label {
    flex: 1;
}

.gas-shipping-method__amount {
    font-weight: 600;
    white-space: nowrap;
}
